import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 11.2909C3 13.9739 4.42 16.3359 6.599 17.8249C6.598 18.6799 6.6 19.8319 6.6 21.0409L10.131 19.2939C10.735 19.4099 11.359 19.4729 12 19.4729C16.952 19.4729 21 15.8299 21 11.2909C21 6.75189 16.952 3.10889 12 3.10889C7.048 3.10889 3 6.75189 3 11.2909Z",
			stroke: "#0517F8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.899 12.328V12.121C11.899 11.443 12.318 11.076 12.738 10.794C13.148 10.518 13.559 10.158 13.559 9.49396C13.559 8.57696 12.816 7.83496 11.9 7.83496C10.984 7.83496 10.24 8.57596 10.24 9.49296",
			stroke: "#0517F8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8979 14.6669C11.8149 14.6669 11.7479 14.7339 11.7489 14.8169C11.7489 14.8999 11.8159 14.9669 11.8989 14.9669C11.9819 14.9669 12.0489 14.8999 12.0489 14.8169C12.0489 14.7339 11.9829 14.6669 11.8979 14.6669",
			stroke: "#0517F8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCommunicate;
